<template>
  <div class="space-y-6 sm:px-6 lg:px-2 lg:max-w-5xl lg:mx-auto" data-test="account-integrations">
    <div class="shadow sm:rounded-md sm:overflow-hidden">
      <div class="bg-white py-6 px-4 sm:p-6">
        <div class="border-b border-gray-200 pb-1">
          <h2 class="text-lg leading-6 font-medium text-gray-900">
            Account Integrations
          </h2>
          <p class="mt-1 text-sm text-gray-500">Your Heffron account integrations</p>
        </div>
        <div class="mt-4">
          <div class="divide-y divide-gray-200">
            <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <div class="text-sm font-medium text-gray-500 flex space-x-2 items-center">
                <img src="https://www.bglcorp.com/wp-content/uploads/2019/07/BGL_DARK.png" class="h-6 w-6"/>
                <h2 class="font-medium">BGL Integration</h2>
              </div>
              <div
                class="mt-1 sm:mt-0 sm:col-span-2 flex items-center justify-end text-sm"
                v-if="!accountUserAccessTokens('bgl')"
              >
                <div class="relative">
                  <m-button tag="a" :href="oAuthBGL" @click="bglLoading = true">Connect</m-button>
                    <div
                      v-if="bglLoading"
                      class="absolute inset-0 flex items-center justify-center bg-blue-800 rounded"
                    >
                      <div class="h-4 w-4">
                        <m-loader class="text-white"/>
                      </div>
                    </div>
                  </div>
              </div>
              <div
                v-else
                class="mt-1 sm:mt-0 sm:col-span-2 flex items-center justify-end text-sm"
              >
                <div class="relative">
                  <m-button :disabled="bglLoading" @click="handleRevoke('bgl')">
                    Revoke
                  </m-button>
                  <div
                    v-if="bglLoading"
                    class="absolute inset-0 flex items-center justify-center bg-blue-800 rounded"
                  >
                    <div class="h-4 w-4">
                      <m-loader class="text-white"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4" v-if="allowClass()">
          <div class="divide-y divide-gray-200">
            <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <div class="text-sm font-medium text-gray-500 flex space-x-2 items-center">
                <img src="https://app.class-pie.com.au/my/login/common/images/webui/images/class_black.png" class="h-8 w-12"/>
                <h2 class="font-medium">Class Integration</h2>
              </div>
              <div
                class="mt-1 sm:mt-0 sm:col-span-2 flex items-center justify-end text-sm"
                v-if="!accountUserAccessTokens('class')"
              >
                <div class="relative">
                  <m-button
                    tag="a"
                    :href="oAuthCLASS"
                    @click="classLoading = true"
                  >Connect</m-button>
                    <div
                      v-if="classLoading"
                      class="absolute inset-0 flex items-center justify-center bg-blue-800 rounded"
                    >
                      <div class="h-4 w-4">
                        <m-loader class="text-white"/>
                      </div>
                    </div>
                  </div>
              </div>
              <div
                v-else
                class="mt-1 sm:mt-0 sm:col-span-2 flex items-center justify-end text-sm"
              >
                <div class="relative">
                  <m-button :disabled="classLoading" @click="handleRevoke('class')">
                    Revoke
                  </m-button>
                  <div
                    v-if="classLoading"
                    class="absolute inset-0 flex items-center justify-center bg-blue-800 rounded"
                  >
                    <div class="h-4 w-4">
                      <m-loader class="text-white"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API, ENDPOINTS } from '@/app/services/api-url';

export default {
  name: 'account-integrations',
  data() {
    return {
      bglLoading: false,
      classLoading: false,
    };
  },
  computed: {
    oAuthBGL() {
      const clientID = process.env.VUE_APP_BGL_CLIENT_ID;
      const callbackURL = process.env.VUE_APP_BGL_CALLBACK_URL;
      const authURL = process.env.VUE_APP_BGL_AUTH_URL;
      return `${authURL}/oauth/authorize?response_type=code&client_id=${clientID}&scope=smsf_partner&redirect_uri=${callbackURL}`;
    },
    oAuthCLASS() {
      const clientID = process.env.VUE_APP_CLASS_CLIENT_ID;
      const callbackURL = process.env.VUE_APP_CLASS_CALLBACK_URL;
      const authURL = process.env.VUE_APP_CLASS_AUTH_URL;
      return `${authURL}/connect/authorize?response_type=code&client_id=${clientID}&scope=class_profile%20offline_access%20fund.read&prompt=consent&redirect_uri=${callbackURL}`;
    },
    accountUserAccessTokens() {
      return type => (this.$store.getters['account/getActiveAccountUser'].accessTokens ? this.$store.getters['account/getActiveAccountUser'].accessTokens[type] : null);
    },
    accountUserUUID() {
      return this.$store.getters['account/getActiveAccountUser'].uuid;
    },
  },
  methods: {
    allowClass() {
      if (process.env.VUE_APP_ALLOW_CLASS === 'false') {
        return false;
      }
      return true;
    },
    handleLoading(type, status) {
      if (type === 'bgl') {
        this.bglLoading = status;
      }
      if (type === 'class') {
        this.classLoading = status;
      }
    },
    handleRevoke(type) {
      this.handleLoading(type, true);
      return API.patch(`${ENDPOINTS.PATCH_ACCESS_TOKEN}/${this.accountUserUUID}/accesstoken?type=${type}`)
        .then((res) => {
          if (res.status === 201) {
            return this.$store.dispatch('account/refreshAccounts');
          }
          throw new Error('Failed to revoke access token!');
        })
        .then(() => {
          this.handleLoading(type, false);
        })
        .catch(err => console.log(err));
    },
  },
};

</script>
